class ColorSwatchHandler extends HTMLElement {
    constructor() {
        super();
        this.swatches = this.querySelectorAll(".color-swatch-image-wrapper");
        this.init();
    }

    init() {
        this.swatches.forEach((swatch) => {
            swatch.addEventListener("click", (event) => this.handleSwatchClick(event));
            swatch.addEventListener("click", (event) => this.handleSwatch(event));
        });
        this.swatches.forEach((swatch) => {
            swatch.addEventListener("mouseenter", (event) => this.handleSwatch(event));
            swatch.addEventListener("mouseleave", (event) => this.resetToFirstVariant(event));
        });
    }

    handleSwatch(event) {
        const swatch = event.currentTarget;
        const productCard = swatch.closest("product-card");

        if (!productCard) return;

        const newImage = swatch.querySelector(".color-swatch-image").getAttribute("data-swatch-src");
        const newProductUrl = swatch.getAttribute("data-swatch-url");
        const newProductTitle = swatch.getAttribute("data-swatch-title");

        const productCardImage = productCard.querySelector(".product-card-img");
        if (productCardImage && newImage) {
            productCardImage.src = newImage;
            productCardImage.setAttribute("srcset", newImage);
        }

        const productLinks = productCard.querySelectorAll("[data-card-link]");
        const productCardTitle = productCard.querySelector("[data-card-link] .text-headings");
        if (productLinks || productCardTitle && newProductUrl) {
            productLinks.forEach((productLink) => productLink.href = newProductUrl);
            productCardTitle.innerHTML = newProductTitle;
        }
    }

    handleSwatchClick(event) {
        const swatch = event.currentTarget;
        const productCard = swatch.closest("product-card");

        if (!productCard) return;

        const newImage = swatch.querySelector(".color-swatch-image").getAttribute("data-swatch-src");
        const newProductUrl = swatch.getAttribute("data-swatch-url");
        const newProductTitle = swatch.getAttribute("data-swatch-title");

        productCard.querySelectorAll("custom-color-swatch .color-swatch-image-wrapper").forEach((swatch) => {
            swatch.classList.remove("selected")
        });
        swatch.classList.add("selected");

        productCard.setAttribute("data-default-image", newImage);
        productCard.setAttribute("data-default-url", newProductUrl);
        productCard.setAttribute("data-default-title", newProductTitle);
    }

    resetToFirstVariant(event) {
        const productCard = event.currentTarget.closest("product-card");
        if (!productCard) return;

        const defaultImage = productCard.getAttribute("data-default-image");
        const defaultUrl = productCard.getAttribute("data-default-url");
        const defaultTitle = productCard.getAttribute("data-default-title");

        const productCardImage = productCard.querySelector(".product-card-img");
        if (productCardImage && defaultImage) {
            productCardImage.src = defaultImage;
            productCardImage.setAttribute("srcset", defaultImage);
        }

        const productLinks = productCard.querySelectorAll("[data-card-link]");
        const productCardTitle = productCard.querySelector("[data-card-link] .text-headings");
        if (productLinks || productCardTitle && defaultUrl) {
            productLinks.forEach((productLink) => productLink.href = defaultUrl);
            productCardTitle.innerHTML = defaultTitle;
        }
    }
}

window.customElements.define('custom-color-swatch', ColorSwatchHandler);